import React from 'react'

import { Card, Center, Flex, Stack, Text, Title } from '@mantine/core'
import { IconAlertCircleFilled } from '@tabler/icons-react'
import { Title as RATitle, useTranslate } from 'react-admin'
import { PermissionApiDTO } from '../codegen/generated/Api.schemas'

type ForbiddenProps = {
  permission: PermissionApiDTO
}

export const Forbidden = ({ permission }: ForbiddenProps): JSX.Element => {
  const t = useTranslate()

  return (
    <Card shadow="xs" py="xl">
      <RATitle title="Forbidden" />
      <Center>
        <Stack ta="center" w="100%">
          <Flex align="center" justify="center" gap="xs">
            <IconAlertCircleFilled color="var(--mantine-color-orange-6)" size={32} />
            <Title order={1} c="orange">
              403
            </Title>
          </Flex>
          <Title order={2} mb="md">
            {t('pages.users.lackingPermission')}
          </Title>
          <Text fs="italic" display="block">
            → {t(`pages.users.permissionsList.${permission}`)}
          </Text>
        </Stack>
      </Center>
    </Card>
  )
}
